<script>
import isInteger from 'lodash/isInteger';
import ButtonPostPublish from './button-post-publish';
import CreateSimilar from './create-similar';
export default {
    components: {
        ButtonPostPublish,
        CreateSimilar
    },

    props: {
        editLimitTimestampSeconds: {
            type: Number,
            required: false,
            default: null,
            validator: (value) => {
                return value === null || (isInteger(value) && value >= 0);
            }
        },

        postPrivateCode: {
            type: String,
            required: true,
        },

        isFree: {
            type: Boolean,
            required: true,
        },

        deleteRedirectUrl: {
            type: String,
            required: true,
        },

        maxCopies: {
            type: Number,
            required: false,
            default: 0,
        },

        permissions: {
            type: Object,
            required: true,
        }

    },

    data: function() {
        return {
            remainingEditSeconds: null,
            suspendPostButtonDisabled: false,
            deletePostButtonDisabled: false,
            duplicatePostButtonDisabled: false,
            editPostButtonDisabled: false,
            promotePostButtonDisabled: false,
            publishButtonDisabled: false,
        }
    },


    created() {
        if(this.editLimitTimestampSeconds !== null) {
            this.remainingEditSeconds = Math.round(this.editLimitTimestampSeconds - Date.now()/1000);
            if(this.remainingEditSeconds >= 0) {
                const intervalId = setInterval(() => {
                    const remaining = Math.round(this.editLimitTimestampSeconds - Date.now()/1000);
                    if(remaining < 0){
                        clearInterval(intervalId);
                    }
                    this.remainingEditSeconds = remaining;
                }, 1000);
            }
        }
    },

    mounted() {
        this.suspendPostButtonDisabled = !this.permissions.your_posts;
        this.deletePostButtonDisabled = !this.permissions.delete_posts;
        this.duplicatePostButtonDisabled = !this.permissions.your_posts;
        this.editPostButtonDisabled = !this.permissions.your_posts;
        this.promotePostButtonDisabled = !this.permissions.your_posts;
        this.publishButtonDisabled = !this.permissions.your_posts;
    },

    methods: {
        suspendPost() {
            this.suspendPostButtonDisabled = true;

            this.$root.$emit('openSuspendPostLightbox', {
                onCloseCallback: (error) => {
                    this.suspendPostButtonDisabled = false;
                },
                postPrivateCode: this.postPrivateCode,
                openModal: !this.isFree,
            });
        },

        deletePost() {
            this.deletePostButtonDisabled = true;

            this.$root.$emit('openDeletePostLightbox', {
                onCloseCallback: (error) => {
                    this.deletePostButtonDisabled = false;
                },
                postPrivateCode: this.postPrivateCode,
                redirectUrl: this.deleteRedirectUrl,
                hasActiveCtt: !this.isFree,
            });
        },

        duplicatePost() {
            this.duplicatePostButtonDisabled = true;

            this.$root.$emit('openDuplicatePostLightbox', {
                onCloseCallback: (error) => {
                    this.duplicatePostButtonDisabled = false;
                },
                postPrivateCode: this.postPrivateCode,
                maxCopies: this.maxCopies,
            });
        },

    },
}
</script>
